import { Tab, Tabs } from "@mui/material"
import { USER_NAME_ROLE } from "src/app/auth";

interface LogTabsProps {
    activeTab: number;
    handleChange: (event: React.SyntheticEvent, newValue: number) => void;
}

const LogTabs: React.FC<LogTabsProps> = ({ activeTab, handleChange }) => {
    const isAdmin = sessionStorage.getItem(USER_NAME_ROLE) === "admin";

    const tabs = [
        <Tab key="config" label="Configuration Logs" />,
        <Tab key="software" label="Software Logs" />,
        <Tab key="system-health" label="System Health Logs" />,
        <Tab key="system-status" label="System Status Logs" />
    ];

    if (isAdmin) {
        tabs.push(<Tab key="license" label="License Logs" />);
        tabs.push(<Tab key="auth" label="Auth Logs" />);
        tabs.push(<Tab key="audit-failure" label="Audit Failure Logs" />);
    }
    return (
        <Tabs value={activeTab} onChange={handleChange} aria-label="logs tabs"
            sx={{
                "& .MuiTab-root": {
                    backgroundColor: "#FFFFFF", // light blue-gray background
                    border: "1px solid #c7dbff",
                    borderRadius: "6px",
                    fontWeight: 600,
                    color: "#434343",
                    textTransform: "none",
                    minHeight: 40,
                    marginRight: "8px",
                    transition: "all 0.2s ease-in-out",

                    "&.Mui-selected": {
                        color: "#FFFFFF",
                        backgroundColor: "#1D4580",
                        borderColor: "#0d47a1",
                        boxShadow: "0 2px 6px rgba(13, 71, 161, 0.2)",
                    },
                },
                "& .MuiTabs-indicator": {
                    display: "none",
                },
            }}
        >
            {tabs}
        </Tabs>
    )
}

export default LogTabs;